import { ILandingSettings } from 'detailsv2/LandingV2/types';

export const labelsMap: Record<string, string> = {
  textOverImages: 'Show text over left side images',
  showInfoEventsInTravelBrief: 'Show Information events on Travel Brief',
  displayDatesDdMmYyyy: 'Display dates in DD/MM/YYYY format',
  displayTimes24h: 'Display times in 24-hour format',
};

/*
  To add a new setting -> add a new key to the group, and the new switch will appear.
  If a new group is needed, add it similarly and use {@link ProposalSettingsGroup} to show new group.
 */
export const proposalSettingsMap: Record<string, Array<keyof ILandingSettings>> = {
  display: ['textOverImages', 'showInfoEventsInTravelBrief'],
  date: ['displayDatesDdMmYyyy', 'displayTimes24h'],
  language: ['language'],
};
